// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Ua1","newExpiryDate":"styles_newExpiryDate__U1fc6","footer":"styles_footer__3Tz14"};